/* eslint-disable no-console */
import {ReloadOutlined} from '@ant-design/icons';
import {Button, Flex} from 'antd';
import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import Loader from '../../components/Loader/Loader';
import esgPrefill from '../../services/modules/ESG/ESGPrefill';
import pillarsAPI from '../../services/modules/ESG/pillarsAPI';
import Year from '../../shared/Year';
import {checkCurrentYearOrBelow} from '../../utils/commonFunctions';
// import {yearSelect} from '../../utils/FormUtils/yearSelect';
import {shouldBlockFreeOrTrial} from '../../utils/SubscriptionHelper';

import {SelectedYear} from './constants/YearContext';
import Frameworks from './utils/Frameworks';

const ESG: React.FC = () => {
  const [searchParam, setSearchParams] = useSearchParams();
  const [selectedYear, setSelectedYear] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  // const firstYear = yearSelect();
  const [refresing, setRefresing] = useState<boolean>();
  const [refreshPage, setRefreshPage] = useState(false);

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
    setSelectedYear(currentYear);
  }, []);

  useEffect(() => {
    if (selectedYear) {
      setIsLoading(true);
      pillarsAPI(selectedYear, true)
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectedYear, refreshPage]);

  const handleRefreshClick = () => {
    setRefresing(true);
    Promise.all([esgPrefill(selectedYear)])
      .then(() => {
        setRefreshPage(!refreshPage);
      })
      .catch(() => {})
      .finally(() => {
        setRefresing(false);
      });
  };

  return (
    selectedYear && (
      <SelectedYear.Provider value={selectedYear}>
        <Flex justify="space-between" align="center" style={{width: '100%'}}>
          <Year
            setSelectedYear={setSelectedYear}
            isESG={true}
            colSpan={24}
            isDisabled={isLoading}
          />
          {shouldBlockFreeOrTrial() ? (
            <></>
          ) : (
            <Button
              type="default"
              icon={<ReloadOutlined />}
              style={{marginBottom: '10px'}}
              title="Pre-filling data from Carbon Accounting"
              loading={refresing}
              onClick={() => {
                handleRefreshClick();
              }}
            ></Button>
          )}
        </Flex>
        {isLoading ? (
          <Loader />
        ) : (
          <div className="page" style={{height: 'unset'}}>
            <Frameworks />
          </div>
        )}
      </SelectedYear.Provider>
    )
  );
};

export default ESG;
